import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IState } from '../../../shared/models/state';
import { getAvailableTypesSelector } from '../pricing-numbers.reducer';

@Component({
  selector: 'cc-number-types-dropdown',
  templateUrl: './number-types-dropdown.component.html',
  styleUrls: ['./number-types-dropdown.component.scss']
})
export class NumberTypesDropdownComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() controlName: string;

  public filterTypes$: Observable<string[]>;

  constructor(private store: Store<IState>) {}

  ngOnInit() {
    this.filterTypes$ = this.store.select(getAvailableTypesSelector);
  }
}
